import * as React from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby"
import {
  Navbar,
  NavItem,
  NavbarToggler,
  NavbarBrand,
  Nav,
  DropdownToggle,
  Collapse,
  Button
} from "shards-react"
import Logo from "../logos/csg"

// View Components
import MobileView from "../common/mobileView"
import BrowserView from "../common/browserView"

// Images
import OfficialLogo from "../images/csg-learning.png"
import Switcher from "../components/switcher"

import { isMobile } from "react-device-detect"

// Menus
import MainMobileMenu from "../menus/mainMobileMenu"

// Navigation Items
import NavigationLink from "../header/navigationLink"

import { getCountry } from "../js/getCountry"
import { routify } from "../js/routify"

class Header extends React.Component {
  constructor(props) {
    super(props)

    this.toggle = this.toggle.bind(this)
    this.toggleNavbar = this.toggleNavbar.bind(this)

    this.state = {
      open: false,
      dropdownOpen: false,
      collapseOpen: false,

      // Routes with Header data
      routes: require("../data/routes.json"),
      country: getCountry(this.props.countryCode) || getCountry("JM")
    }
  }

  // Toggeles the mobile dropdown to switch country
  toggle() {
    this.setState(prevState => {
      return { open: !prevState.open }
    })
  }

  /// Toggles Navbar
  toggleNavbar() {
    this.setState({
      ...this.state,
      ...{
        collapseOpen: !this.state.collapseOpen
      }
    })
  }

  render() {
    return (
      <>
        {/* Top logo */}
        <MobileView>
          <a
            href={
              this.state.country.slug
                ? "/" + this.state.country.slug + this.state.routes.home
                : "/" + this.state.routes.home
            }
          >
            <Logo />
          </a>
        </MobileView>
        <Navbar
          type="light"
          theme="light"
          expand="md"
          style={{ height: "auto" }}
          className={isMobile ? "sticky-top" : ""}
        >
          <NavbarBrand
            className="navbar-brand"
            href={routify(
              this.state.country.countryCode || "",
              this.state.routes.home
            )}
          >
            {/* Display the Company Logo on desktop devices */}
            <BrowserView>
              <img
                className="ml-3"
                src={OfficialLogo}
                style={{ width: "30%" }}
              />
            </BrowserView>

            {/* Display the simple text on mobile devices */}
            <MobileView>CSG Learning</MobileView>
          </NavbarBrand>

          <Switcher
            hideName={isMobile}
            header
            hidden={this.props.hideCountrySwitcher}
            countryCode={this.state.country.countryCode}
          />

          <NavbarToggler onClick={this.toggleNavbar} />

          <Collapse open={this.state.collapseOpen} navbar>
            <Nav
              navbar
              className="ml-auto mr-5"
              style={{ height: "100%", width: "100%" }}
            >
              <NavigationLink
                title="About"
                href={this.state.routes.about}
                countryCode={this.state.country.countryCode}
              />
              <NavigationLink
                title="Programmes"
                href={this.state.routes.programmes}
                countryCode={this.state.country.countryCode}
              />
              <NavigationLink
                title="Admissions"
                href={this.state.routes.admissions}
                countryCode={this.state.country.countryCode}
              />
              <NavigationLink
                title="Courses"
                href={this.state.routes.courses}
                countryCode={this.state.country.countryCode}
              />
              <NavigationLink
                title="Contact"
                href={this.state.routes.contact}
                countryCode={this.state.country.countryCode}
              />

              <BrowserView>
                <NavItem>
                  <Button
                    target="_blank"
                    href={this.state.routes.apply}
                    className="ml-1"
                  >
                    Apply
                  </Button>
                </NavItem>
              </BrowserView>
            </Nav>

            <MainMobileMenu
              countryCode={this.props.countryCode || "JM"}
              routes={this.state.routes}
            />
          </Collapse>
        </Navbar>
      </>
    )
  }
}

Header.propTypes = {
  siteTitle: PropTypes.string
}

Header.defaultProps = {
  siteTitle: ``
}

export default Header
